<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditFormDetails" (ngSubmit)="saveOrUpdate()" RestrictFocus >

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.sales_network_id.nullable}">{{ fields.sales_network_id.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown [style]="{'width':'100%'}" formControlName="sales_network_id" [options]="store_items" [(ngModel)]="selected_store"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditFormDetails" [validation]="fields.sales_network_id"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{editingElement.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'storeGroupDetail.storeGroupDetail' |translate }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-details/store-group-details-form.component.html